<template>
    <div>
        <div id="headline-news-wrapper">
            <div id="headline-news-wrapper-bg">
                <!-- <el-carousel indicator-position="outside">
                    <el-carousel-item v-for="item in 1" :key="item">
                    </el-carousel-item>
                </el-carousel> -->
                <router-link
                            id="headline-news"
                            :to="{
                                path: '/layout/association-trends-detail',
                                query: {
                                    id: focusNews.id,
                                    type: focusNews.type,
                                },
                            }"
                        >
                    <el-tooltip :content="focusNews.title" placement="top">
                        <h2 class="ellipsis_one headline-news-title">
                            {{ focusNews.title }}
                        </h2>
                    </el-tooltip>

                            <p class="ellipsis_one headline-news-origin">
                                {{ focusNews.subTitle }}
                            </p>
                        </router-link>
                <div class="headline-news-line"></div>
            </div>
        </div>
        <!-- banner -->
        <div id="banner-wrapper">
            <div id="banner">
                <div class="banner-lf">
                    <el-carousel>
                        <el-carousel-item
                            v-for="banner in bannerList"
                            :key="banner.Id"
                        >
                            <a :href="banner.Url" target="_blank">
                                <img
                                    class="banner-item-img"
                                    :src="banner.ImageUrl"
                                />
                            </a>
                            <div class="banner-item-title">
                                <p class="ellipsis_one">{{ banner.Name }}</p>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="banner-rg">
                    <router-link
                        :to="bannerRgMoreLink"
                        target="_blank"
                        class="banner-rg_more"
                        >更多 ></router-link
                    >
                    <el-tabs
                        v-model="bannerRgTitle"
                        @tab-click="changeBannerRgTab"
                    >
                        <el-tab-pane label="实时要闻" name="factualNews">
                            <ul class="banner-info">
                                <li
                                    v-for="factualNews in factualNewsList"
                                    :key="factualNews.Id"
                                >
                                    <router-link
                                        class="banner-info-item"
                                        :to="`/layout/association-trends-detail?type=1&id=${factualNews.Id}`"
                                        target="_blank"
                                    >
                                        <p class="content">
                                            <span class="dot activeDot"></span
                                            ><span class="ellipsis_one title">{{
                                                factualNews.Title
                                            }}</span>
                                        </p>
                                        <p class="date">
                                            {{
                                                factualNews.UpdateTime
                                                    | traverseDate('date')
                                            }}
                                        </p>
                                    </router-link>
                                </li>
                            </ul>
                        </el-tab-pane>
                        <el-tab-pane label="协会动态" name="associationTrend">
                            <ul class="banner-info">
                                <li
                                    v-for="bannerNews in bannerNewsList"
                                    :key="bannerNews.Id"
                                >
                                    <router-link
                                        class="banner-info-item"
                                        :to="`/layout/association-trends-detail?type=2&id=${bannerNews.Id}`"
                                        target="_blank"
                                    >
                                        <p class="content">
                                            <span class="dot activeDot"></span
                                            ><span class="ellipsis_one title">{{
                                                bannerNews.Title
                                            }}</span>
                                        </p>
                                        <p class="date">
                                            {{
                                                bannerNews.UpdateTime
                                                    | traverseDate('date')
                                            }}
                                        </p>
                                    </router-link>
                                </li>
                            </ul>
                        </el-tab-pane>
                        <el-tab-pane label="通知公告" name="notice">
                            <ul class="banner-info">
                                <li
                                    v-for="notice in noticeList"
                                    :key="notice.Id"
                                >
                                    <router-link
                                        class="banner-info-item"
                                        :to="`/layout/association-trends-detail?type=2&id=${notice.Id}`"
                                        target="_blank"
                                    >
                                        <p class="content">
                                            <span class="dot activeDot"></span
                                            ><span class="ellipsis_one title">{{
                                                notice.Title
                                            }}</span>
                                        </p>
                                        <p class="date">
                                            {{
                                                notice.UpdateTime
                                                    | traverseDate('date')
                                            }}
                                        </p>
                                    </router-link>
                                </li>
                            </ul>
                        </el-tab-pane>
                    </el-tabs>

                    <!-- <ul class="banner-low">
                        <li class="banner-low-item" @click="goStudy()">
                            <div class="inner">
                                <img src="@/assets/image/index/banner_low01.png" />
                                <p class="banner-low-title">学习助手</p>
                            </div>
                        </li>
                        <li class="banner-low-item" @click="goInfoPool()">
                            <div class="inner">
                                <img src="@/assets/image/index/banner_low02.png" />
                                <p class="banner-low-title">信息交流</p>
                            </div>
                        </li>
                        <li class="banner-low-item" @click="goZjt()">
                            <div class="inner">
                                <img src="@/assets/image/index/banner_low03.png" />
                                <p class="banner-low-title">驻京通</p>
                            </div>
                        </li>
                        <li class="banner-low-item" @click="goSience()">
                            <div class="inner">
                                <img src="@/assets/image/index/banner_low04.png" />
                                <p class="banner-low-title">科技舱</p>
                            </div>
                        </li>
                    </ul> -->
                </div>
            </div>
        </div>
        <!-- 协会 -->
        <div id="accociation-wrapper">
            <div id="accociation">
                <div class="rg-group-box pd_t0">
                    <h2 class="group_title">
                        <span>协会分会</span>
                    </h2>
                    <div class="accociation-card-list">
                        <div class="accociation-card">
                            <div class="accociation-card_tp">
                                <span>信息分会</span>
                                <img src="@/assets/image/indexNew/association_log1.png" />
                            </div>
                            <ul class="association-card_btm">
                                <li class="association-item">
                                    <router-link
                                        to="/layout/info-branch-introduction?id=1"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_1_icon1.png"
                                        />
                                        <span>关于分会</span>
                                    </router-link>
                                </li>
                                <li class="association-item">
                                    <router-link
                                        to="/layout/enterprise-branch?type=1"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_1_icon2.png"
                                        />
                                        <span>分会活动</span>
                                    </router-link>
                                </li>
                                <!-- <li class="association-item">
                                        <router-link to="/layout/think-tanks">
                                            <img src="@/assets/image/index/association_1_3.png" />
                                            <span>合作智库</span>
                                        </router-link>
                                    </li> -->
                                <li class="association-item">
                                    <router-link
                                        to="/layout/export-forum"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_1_icon3.png"
                                        />
                                        <span>专家讲坛</span>
                                    </router-link>
                                </li>
                                <li class="association-item">
                                    <router-link
                                        to="/layout/info-pool"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_1_icon4.png"
                                        />
                                        <span>信息交流</span>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="accociation-card">
                            <div class="accociation-card_tp">
                                <span>双招双引分会</span>
                                <img src="@/assets/image/indexNew/association_log2.png" />
                            </div>
                            <ul class="association-card_btm">
                                <li class="association-item">
                                    <router-link
                                        to="/layout/info-branch-introduction?id=2"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_2_icon1.png"
                                        />
                                        <span>关于分会</span>
                                    </router-link>
                                </li>
                                <li class="association-item">
                                    <router-link
                                        to="/layout/enterprise-branch?type=2"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_2_icon2.png"
                                        />
                                        <span>分会活动</span>
                                    </router-link>
                                </li>
                                <li class="association-item">
                                    <a
                                        href="http://zjt.zjbinfo.com/home"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_2_icon3.png"
                                        />
                                        <span>&nbsp;驻京通&nbsp;&nbsp;</span>
                                    </a>
                                </li>
                                <li class="association-item">
                                    <router-link
                                        to="/layout/project-list"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_2_icon4.png"
                                        />
                                        <span>项目展示</span>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="accociation-card">
                            <div class="accociation-card_tp">
                                <span>医药卫生分会</span>
                                <img src="@/assets/image/indexNew/association_log3.png" />
                            </div>
                            <ul class="association-card_btm">
                                <li class="association-item">
                                    <router-link
                                        to="/layout/info-branch-introduction?id=3"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_3_icon1.png"
                                        />
                                        <span>关于分会</span>
                                    </router-link>
                                </li>
                                <li class="association-item">
                                    <router-link
                                        to="/layout/enterprise-branch?type=3"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_3_icon2.png"
                                        />
                                        <span>分会活动</span>
                                    </router-link>
                                </li>
                                <li class="association-item">
                                    <router-link
                                        to="/layout/medical-resource"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_3_icon3.png"
                                        />
                                        <span>医疗资源</span>
                                    </router-link>
                                </li>
                                <li class="association-item">
                                    <router-link
                                        to="/layout/medical-science"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_3_icon4.png"
                                        />
                                        <span>医疗科普</span>
                                    </router-link>
                                </li>
                                <li class="association-item">
                                    <router-link
                                        to="/layout/medical-service-guideline"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_3_icon5.png"
                                        />
                                        <span>服务指引</span>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                        <div class="accociation-card">
                            <div class="accociation-card_tp">
                                <span>企业分会</span>
                                <img src="@/assets/image/indexNew/association_log4.png" />
                            </div>
                            <ul class="association-card_btm">
                                <li class="association-item">
                                    <router-link
                                        to="/layout/info-branch-introduction?id=4"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_4_icon1.png"
                                        />
                                        <span>关于分会</span>
                                    </router-link>
                                </li>
                                <li class="association-item">
                                    <router-link
                                        to="/layout/enterprise-branch?type=4"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_4_icon2.png"
                                        />
                                        <span>分会活动</span>
                                    </router-link>
                                </li>
                                <li class="association-item">
                                    <router-link
                                        to="/layout/vip-list"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_4_icon3.png"
                                        />
                                        <span>会员展示</span>
                                    </router-link>
                                </li>
                                <li class="association-item">
                                    <a>
                                        <img
                                            src="@/assets/image/indexNew/association_4_icon4.png"
                                        />
                                        <span>在线学习</span>
                                    </a>
                                </li>
                                <li class="association-item">
                                    <a>
                                        <img
                                            src="@/assets/image/indexNew/association_4_icon5.png"
                                        />
                                        <span>知识分享</span>
                                    </a>
                                </li>
                                <li class="association-item">
                                    <router-link
                                        to="/layout/policy-interpretation"
                                        target="_blank"
                                    >
                                        <img
                                            src="@/assets/image/indexNew/association_4_icon6.png"
                                        />
                                        <span>政策解读</span>
                                    </router-link>
                                </li>
                                <li class="association-item">
                                    <a>
                                        <img
                                            src="@/assets/image/indexNew/association_4_icon7.png"
                                        />
                                        <span>会员福利</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- app -->
        <div id="other-app-wrapper">
            <div id="other-app">
                <div class="app-item">
                    <a href="https://ixuexi.aigc.cctv.com/dyzs/login" target="_blank">
                        <img src="@/assets/image/indexNew/app_icon1.png" />
                        <p>学习助手</p>
                    </a>   
                </div>
                <div class="app-item">
                    <router-link
                        to="/layout/info-pool?id=4"
                        target="_blank"
                    >
                        <img src="@/assets/image/indexNew/app_icon2.png" />
                        <p>信息交流</p>
                    </router-link>
                </div>
                <div class="app-item">
                    <a href="http://zjt.zjbinfo.com/home" target="_blank">
                        <img src="@/assets/image/indexNew/app_icon3.png" />
                        <p>驻京通</p>
                    </a>
                </div>
                <div class="app-item">
                    <a href="https://yp.bsicbigdata.com/" target="_blank">
                        <img src="@/assets/image/indexNew/app_icon4.png" />
                        <p>招商大脑</p>
                    </a>
                </div>
            </div>
        </div>
        <!-- lf rg  -->
        <!-- 驻京党建 驻京办风采 -->
        <div id="news-wrapper">
            <div id="news">
                <div class="news-lf">
                    <div class="group-box pd_t0">
                        <h2 class="group_title">
                            <span>驻京党建</span>
                            <router-link
                                to="/layout/association-party?id=1"
                                target="_blank"
                                >更多 ></router-link
                            >
                        </h2>
                        <ul class="news-political">
                            <li
                                v-for="politicalParty in politicalPartyList"
                                :key="politicalParty.Id"
                                @click="goPartyBuildDetail(politicalParty)"
                            >
                                <p class="ellipsis_one">
                                    <span class="dot activeDot"></span>
                                    <span class="news-political-info">{{
                                        politicalParty.Title
                                    }}</span>
                                </p>
                                <p class="news-class">
                                    <span class="news-tag">{{
                                        politicalParty.Description
                                    }}</span>
                                    <span>｜</span>
                                    <span class="news-date">{{
                                        politicalParty.UpdateTime
                                    }}</span>
                                </p>
                            </li>
                        </ul>
                    </div>
                </div>
                <!-- 驻京办风采 会员企业 -->
                <div class="news-rg">
                    <router-link
                    :to="newsRgMoreLink"
                    target="_blank"
                    class="news_rg_more"
                    >更多 ></router-link
                >
                    <el-tabs v-model="newsRgTitle" @tab-click="changenewsRgTab">
                        <el-tab-pane label="驻京办风采" name="institution">
                            <ul class="news-association">
                                <li
                                    v-for="office in officeList"
                                    :key="office.Id"
                                    @click="goOfficeDetail(office)"
                                >
                                    <p class="ellipsis_one">
                                        <span class="dot activeDot"></span>
                                        <span class="news-association-info">{{
                                            office.Title
                                        }}</span>
                                    </p>
                                    <p class="news-class">
                                        <span class="news-tag">{{
                                            office.SubTitle
                                        }}</span>
                                        <span>｜</span>
                                        <span class="news-date">{{
                                            office.UpdateTime
                                        }}</span>
                                    </p>
                                </li>
                            </ul>
                        </el-tab-pane>
                        <el-tab-pane label="会员企业风采" name="company">
                            <div class="swipper-div">
                            <div class="swipper-prev" @click="prev()">
                                <!-- <p> &lt; </p> -->
                                <div class="swiper-button-prev" slot="button-prev"></div>
                            </div>
                            <!-- <div class="swiper-container"> -->
                                <swiper class="swiper" :options="swiperOption" ref="mySwiper">
                                    <swiper-slide v-for="vip,index in vipList" :key="index">
                                        <img :src="vip.Logo" class="vipLogo" @click="goCompanyDetail(vip)"/>
                                    </swiper-slide>
                                </swiper>
                            <!-- </div> -->
                            <div class="swipper-next " @click="next()">
                                <!-- <p> &gt; </p> -->
                                <div class="swiper-button-next" slot="button-next"></div>
                            </div>
                        </div>
                        </el-tab-pane>
                    </el-tabs>
                    <!-- <div class="group-box pd_t0">
                        <h2 class="group_title">
                            <span class="fiveWord"></span>
                            <router-link
                                to="/layout/institution-list"
                                target="_blank"
                                >更多 ></router-link
                            >
                        </h2>
                        
                    </div> -->
                </div>
            </div>
        </div>
        <!-- 信息交流 -->
        <div id="info-pool-wrapper">
            <div id="info-pool">
                <router-link
                    :to="infoPoolMoreLink"
                    target="_blank"
                    class="info-pool_more"
                    >更多 ></router-link
                >
                <el-tabs v-model="infoPoolTitle" @tab-click="changeInfoPoolTab">
                    <el-tab-pane label="每日信息" name="everyDayNews">
                        <div class="info-pool-ul">
                            <div class="info-pool-lf">
                                <h3>信息交流</h3>
                                <p>致力于建立可靠优质的连接</p>
                                <!-- <ul>
                                    <li>高效的信息</li>
                                    <li>精准的传播</li>
                                    <li>信息创造价值</li>
                                </ul> -->
                            </div>
                            <ul class="info-pool-rg">
                                <li
                                    class="info-data"
                                    v-for="infoPool in everyDayNewsList"
                                    :key="infoPool.ProjectId"
                                >
                                    <h4 class="ellipsis_two">
                                        {{ infoPool.Name }}
                                    </h4>
                                    <!-- <p class="ellipsis_four">{{ infoPool.ProjectDesc }}</p> -->
                                    <div class="info-data-bar">
                                        <div>
                                            <span class="info-pool-tag">{{
                                                infoPool.Invest
                                            }}</span>
                                            <span>｜</span>
                                            <span class="news-date">{{
                                                infoPool.CTime
                                            }}</span>
                                        </div>
                                        <a
                                            class="info-pool-button"
                                            @click="getProjectDownOther(infoPool)"
                                            >会员免费下载</a
                                        >
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="专报信息" name="specialReportNews">
                        <div class="info-pool-ul">
                            <div class="info-pool-lf">
                                <h3>信息交流</h3>
                                <p>致力于建立可靠优质的连接</p>
                                <!-- <ul>
                                    <li>高效的信息</li>
                                    <li>精准的传播</li>
                                    <li>信息创造价值</li>
                                </ul> -->
                            </div>
                            <ul class="info-pool-rg">
                                <li
                                    class="info-data"
                                    v-for="infoPool in specialReportNewsList"
                                    :key="infoPool.ProjectId"
                                >
                                    <h4 class="ellipsis_two">
                                        {{ infoPool.Name }}
                                    </h4>
                                    <!-- <p class="ellipsis_four">{{ infoPool.ProjectDesc }}</p> -->
                                    <div class="info-data-bar">
                                        <div>
                                            <span class="info-pool-tag">{{
                                                infoPool.Invest
                                            }}</span>
                                            <span>｜</span>
                                            <span class="news-date">{{
                                                infoPool.CTime
                                            }}</span>
                                        </div>
                                        <a
                                            class="info-pool-button"
                                            @click="getProjectDown(infoPool)"
                                            >会员免费下载</a
                                        >
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="共享信息" name="shareNews">
                        <div class="info-pool-ul">
                            <div class="info-pool-lf">
                                <h3>信息交流</h3>
                                <p>致力于建立可靠优质的连接</p>
                                <!-- <ul>
                                    <li>高效的信息</li>
                                    <li>精准的传播</li>
                                    <li>信息创造价值</li>
                                </ul> -->
                            </div>
                            <ul class="info-pool-rg">
                                <li
                                    class="info-data"
                                    v-for="infoPool in shareNewsList"
                                    :key="infoPool.ProjectId"
                                >
                                    <h4 class="ellipsis_two">
                                        {{ infoPool.zhujingbanName }}
                                    </h4>
                                    <!-- <p class="ellipsis_four">{{ infoPool.ProjectDesc }}</p> -->
                                    <div class="info-data-bar">
                                        <div>
                                            <span class="info-pool-tag">共享信息</span>
                                            <!-- <span>｜</span>
                                            <span class="news-date">{{
                                                infoPool.CTime
                                            }}</span> -->
                                        </div>
                                        <a
                                            class="info-pool-button"
                                            @click="goShareInfoItem(infoPool)"
                                            >查看详情</a
                                        >
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="智库信息" name="thinkNews">
                        <div class="info-pool-ul">
                            <div class="info-pool-lf">
                                <h3>信息交流</h3>
                                <p>致力于建立可靠优质的连接</p>
                                <!-- <ul>
                                    <li>高效的信息</li>
                                    <li>精准的传播</li>
                                    <li>信息创造价值</li>
                                </ul> -->
                            </div>
                            <ul class="info-pool-rg">
                                <li
                                    class="info-data"
                                    v-for="infoPool in thinkNewsList"
                                    :key="infoPool.ProjectId"
                                >
                                    <h4 class="ellipsis_two">
                                        {{ infoPool.Name }}
                                    </h4>
                                    <!-- <p class="ellipsis_four">{{ infoPool.ProjectDesc }}</p> -->
                                    <div class="info-data-bar">
                                        <div>
                                            <span class="info-pool-tag">{{
                                                infoPool.Invest
                                            }}</span>
                                            <span>｜</span>
                                            <span class="news-date">{{
                                                infoPool.CTime
                                            }}</span>
                                        </div>
                                        <a
                                            class="info-pool-button"
                                            @click="getProjectDownOther(infoPool)"
                                            >会员免费下载</a
                                        >
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <!-- <h2 class="group_title">
                    <span>信息交流</span>
                    <router-link to="/layout/info-pool?id=4" target="_blank">更多 ></router-link>
                </h2> -->
            </div>
        </div>
        <!-- 会员企业 -->
        <!-- <div id ="company-wrapper">
            <div id="company">
                <h2 class="group_title">
                    <span>会员企业风采</span>
                    <router-link to="/layout/company-list"  target="_blank">更多 ></router-link>
                </h2>
                
            </div>
        </div> -->
        <!-- 会员风采：驻京美食 名特优产品 非物质文化遗产 -->
        <div id="institution-wrapper">
            <div id="institution">
                <router-link
                    :to="institutionMoreLink"
                    target="_blank"
                    class="institution_more"
                    >更多 ></router-link
                >
                <el-tabs v-model="institutionTitle" @tab-click="changeInstitutionTab">
                    <el-tab-pane label="驻京美食" name="cityFood">
                        <ul class="delicacy-ul">
                            <li
                                class="delicacy-item"
                                v-for="delicacy in delicacyList"
                                :key="delicacy.Id"
                                @click="goFoodDetail(delicacy)"
                            >
                                <img :src="delicacy.ImageUrl" />
                                <p class="ellipsis_one">{{ delicacy.Title }}</p>
                            </li>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="名特优产品" name="goodProduct">
                        <ul class="delicacy-ul">
                            <li
                                class="delicacy-item"
                                v-for="product in goodProductList"
                                :key="product.Id"
                                @click="goGoodProductDetail(product)"
                            >
                                <img :src="product.ImageUrl" />
                                <p class="ellipsis_one">{{ product.Title }}</p>
                            </li>
                        </ul>
                    </el-tab-pane>
                    <el-tab-pane label="非物质文化遗产" name="culturalHeritage">
                        <ul class="delicacy-ul">
                            <li
                                class="delicacy-item"
                                v-for="culturalHeritage in culturalHeritageList"
                                :key="culturalHeritage.Id"
                                @click="goCulturalHeritageDetail(culturalHeritage)"
                            >
                                <img :src="culturalHeritage.ImageUrl" />
                                <p class="ellipsis_one">
                                    {{ culturalHeritage.Title }}
                                </p>
                            </li>
                        </ul>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <!-- 精彩瞬间 -->
        <div id="brand-wrapper">
            <div id="brand">
                <h2 class="group_title">
                    <span>精彩瞬间</span>
                    <router-link to="/layout/high-light" target="_blank"
                        >更多 ></router-link
                    >
                </h2>
                <ul class="brand-ul">
                    <li
                        class="brand-item"
                        v-for="highLight in highLightList"
                        :key="highLight.Id"
                        @click="goHighLightDetail(highLight)"
                    >
                        <img :src="highLight.ImageUrl" />
                        <!-- <p>{{ highLight.Name }}</p> -->
                        <!-- <p>{{ highLight.SubTitle }}</p> -->
                    </li>
                    <!-- <li class="brand-item">
                        <img src="@/assets/image/index/brand2.png"/>
                        <p>心灵疗愈沙龙</p>
                        <p>打造的中国本土化企业资本</p>
                    </li> -->
                </ul>
            </div>
        </div>
        <el-dialog
            title=""
            :visible.sync="downloadDialogVisible"
            width="416px">
            <h3><i class="el-icon-warning-outline" style="color:#E6A23C;margin-right: 10px;margin-bottom:10px;"></i>{{ downloadDialogTitle }}</h3>
            <p style="padding-left:30px;">{{ downloadDialogContent }}</p>
            <span slot="footer" class="dialog-footer">
                <el-button @click="downloadDialogVisible = false" size="medium">取 消</el-button>
                <el-button type="primary" @click="goLogin()" size="medium">去登录</el-button>
            </span>
        </el-dialog> 
    </div>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import {
    getBannerList,
    getYaowen,
    getDangjianList,
    getProjectList,
    getGongxiang,
    getFoodShop,
    getJingcaiList,
    getZhujingbanWork,
    getPingpaiActivityList,
    getCompanyList,
    getCityShowList,
    getFocusNews,
    getProjectDown,
} from '@services/indexService.js';
import { getCookie } from '@/assets/utils/cookie.js'
export default {
    mixins: [],
    components: {
        swiper,
        swiperSlide,
    },
    data() {
        return {
            bannerRgTitle: 'associationTrend',
            bannerRgMoreLink: '/layout/association-trends?type=2',
            newsRgTitle: 'institution',
            newsRgMoreLink: '/layout/institution-list',
            institutionTitle: 'cityFood',
            infoPoolTitle: 'everyDayNews',
            infoPoolMoreLink: '/layout/info-pool?id=4',
            institutionMoreLink: '/layout/city-food',
            userId: '',
            openInfo: false,
            bannerList: [],
            newsList: [],
            noticeList: [],
            politicalPartyList: [],
            everyDayNewsList: [],
            specialReportNewsList: [],
            shareNewsList: [],
            thinkNewsList: [],
            officeList: [],
            delicacyList: [],
            brandList: [],
            bannerNewsList: [],
            factualNewsList: [],
            highLightList: [],
            vipList: [],
            goodProductList: [],
            culturalHeritageList: [],
            swiperOption: {
                slidesPerView: 4,
                slidesPerColumn: 2,
                spaceBetween: 10,
                grabCursor: true,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev'
                        }
            },
            // 滚动条
            scrollbar: {
                el: '.swiper-scrollbar',
            },
            // 上一张，下一张
            navigation: {
                nextEl: '.swipper-next',
                prevEl: '.swipper-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            swiperGrid: {
                row: 2,
                // fill: row
            },
            focusNews: {
                title: '',
                subTitle: '',
                id: '',
                type: '',
            },
            downloadDialogVisible: false,
            downloadDialogTitle: '请登录会员，上传专报信息后，免费下载',
            downloadDialogContent: '会员每上传1条专报信息，可下载5条专报信息'
        };
    },
    computed: {
        accountId() {
            return this.$store.state.permission.accountId;
        },
    },
    created() {
        this.getFocusNews();
        this.getBannerList();
        this.getFactualNewsList();
        this.getBnnerNewsList();
        this.getNoticeList();
        this.getDangjianList();
        this.getProjectList(4); // 每日信息
        this.getProjectList(3); // 专报信息
        this.getProjectList(1); // 智库信息
        this.getGongxiang(); // 共享信息
        this.getZhujingbanWork();
        this.getFoodShop();
        this.getJingcaiList();
        this.getCompanyList();
        this.getGoodProductList();
        this.getCulturalHeritageList();
    },
    mounted() {
    },
    methods: {
        prev() {
            console.log(this.$refs.mySwiper);
            this.$refs.mySwiper.swiper.slidePrev();
        },
        next() {
            this.$refs.mySwiper.swiper.slideNext();
        },
        getFocusNews() {
            getFocusNews().then((res) => {
                console.log(res);
                if (res.Code == 1) {
                    this.focusNews.title = res.Data.Title;
                    this.focusNews.subTitle = res.Data.SubTitle;
                    this.focusNews.id = res.Data.Id;
                    if (res.Data.Description === '实时要闻') {
                        this.focusNews.type = '1';
                    } else if (res.Data.Description === '协会动态') {
                        this.focusNews.type = '2';
                    } else if (res.Data.Description === '通知公告') {
                        this.focusNews.type = '3';
                    }
                } else {
                    this.$message.error('请求失败');
                }
            });
        },
        getBannerList() {
            getBannerList({ type: 2, count: 100 }).then((res) => {
                console.log(res);
                if (res.Code == 1 && res.Data.length !== 0) {
                    this.bannerList = res.Data;
                } else {
                    this.$message.error('banner请求失败');
                }
            });
        },
        getFactualNewsList() {
            getYaowen({ type: 1, current: 1, size: 8 }).then((res) => {
                console.log(res);
                if (res.Code == 1) {
                    this.factualNewsList = res.Data;
                } else {
                    this.$message.error('时事要闻请求失败');
                }
            });
        },
        getBnnerNewsList() {
            getYaowen({ type: 2, current: 1, size: 8 }).then((res) => {
                console.log(res);
                if (res.Code == 1 && res.Data.length !== 0) {
                    this.bannerNewsList = res.Data;
                } else {
                    this.$message.error('协会动态请求失败');
                }
            });
        },
        getNoticeList() {
            getYaowen({ type: 3, current: 1, size: 8 }).then((res) => {
                console.log(res);
                if (res.Code == 1 && res.Data.length !== 0) {
                    this.noticeList = res.Data;
                } else {
                    this.$message.error('通知公告请求失败');
                }
            });
        },
        // getYaowenList() {
        //     getYaowenList({current: 1, size: 3}).then(res => {
        //         console.log(res);
        //         if (res.Code == 1 && res.Data.length!==0) {
        //             this.newsList = res.Data;
        //         } else {
        //             this.$message.error("要闻请求失败");
        //         }
        //     })
        // },
        getDangjianList() {
            getDangjianList({ current: 1, size: 4 }).then((res) => {
                console.log(res);
                if (res.Code === 1 && res.Data.length !== 0) {
                    this.politicalPartyList = res.Data;
                } else {
                    this.$message.error('党建新闻请求失败');
                }
            });
        },
        /**
         * 4 每日信息
         * 3 专报信息
         * 1 智库信息
         */
        getProjectList(type) {
            getProjectList({ current: 1, size: 6, type: type }).then((res) => {
                if (res.Code == 1) {
                    switch (type) {
                        case 4:
                            this.everyDayNewsList = res.Data;
                            break;
                        case 3:
                            this.specialReportNewsList = res.Data;
                            break;
                        case 1:
                            this.thinkNewsList = res.Data;
                            break;
                        default:
                            break;
                    }
                } else {
                    this.$message.error('信息交流请求失败');
                }
            });
        },
        getFoodShop() {
            getFoodShop({ current: 1, size: 4 }).then((res) => {
                console.log(res);
                if (res.Code == 1 && res.Data.length !== 0) {
                    this.delicacyList = res.Data;
                } else {
                    this.$message.error('驻京美食请求失败');
                }
            });
        },
        getZhujingbanWork() {
            getZhujingbanWork({ current: 1, size: 4 }).then((res) => {
                console.log(res);
                if (res.Code == 1 && res.Data.length !== 0) {
                    this.officeList = res.Data;
                } else {
                    this.$message.error('驻京办风采请求失败');
                }
            });
        },
        getPingpaiActivityList() {
            getPingpaiActivityList({ current: 1, size: 4 }).then((res) => {
                console.log(res);
                if (res.Code == 1 && res.Data.length !== 0) {
                    this.brandList = res.Data;
                } else {
                    this.$message.error('会员风采请求失败');
                }
            });
        },
        getGoodProductList() {
            getCityShowList({ type: 2, current: 1, size: 4 }).then((res) => {
                console.log(res);
                if (res.Code == 1 && res.Data.length !== 0) {
                    this.goodProductList = res.Data;
                } else {
                    this.$message.error('名特优产品请求失败');
                }
            });
        },
        getCulturalHeritageList() {
            getCityShowList({ type: 3, current: 1, size: 4 }).then((res) => {
                console.log(res);
                if (res.Code == 1 && res.Data.length !== 0) {
                    this.culturalHeritageList = res.Data;
                } else {
                    this.$message.error('非物质文化遗产请求失败');
                }
            });
        },
        getJingcaiList() {
            let params = {
                current: 1,
                size: 4,
            };
            getJingcaiList(params).then((res) => {
                console.log(res);
                if (res.Code == 1) {
                    this.highLightList = res.Data;
                } else {
                    this.$message.error('精彩瞬间请求失败');
                }
            });
        },
        getCompanyList() {
            let params = {
                current: 1,
                size: 10000,
                type: 4,
            };
            getCompanyList(params).then((res) => {
                console.log(res);
                if (res.Code == 1 && res.Data.length !== 0) {
                    this.vipList = [...res.Data];
                } else {
                    this.$message.error('会员企业风采请求失败');
                }
            });
        },
        goCompanyDetail(data) {
            let newUrl = this.$router.resolve({
                path: '/layout/company-detail',
                query: {
                    id: data.CompanyId,
                },
            });
            window.open(newUrl.href, '_blank');
        },
        goOfficeDetail(data) {
            let newUrl = this.$router.resolve({
                path: '/layout/institution-detail',
                query: {
                    id: data.Id,
                },
            });
            window.open(newUrl.href, '_blank');
        },
        goNewsDetail(data) {
            let path = '/layout/association-trends-detail';
            let type = 2;
            if (data.Description === '协会动态') {
                type = 2;
            } else if (data.Description === '协会工作') {
                type = 3;
            }
            let newUrl = this.$router.resolve({
                path: path,
                query: {
                    id: data.Id,
                    type: type,
                },
            });
            window.open(newUrl.href, '_blank');
        },
        goPartyBuildDetail(data) {
            let newUrl = this.$router.resolve({
                path: '/layout/association-party-detail',
                query: {
                    id: data.Id,
                    tag: data.Description,
                },
            });
            window.open(newUrl.href, '_blank');
        },
        goFoodDetail(data) {
            let newUrl = this.$router.resolve({
                path: '/layout/city-food-detail',
                query: {
                    id: data.Id,
                },
            });
            window.open(newUrl.href, '_blank');
        },
        goHighLightDetail(data) {
            let newUrl = this.$router.resolve({
                path: '/layout/high-light-detail',
                query: {
                    id: data.Id,
                },
            });
            window.open(newUrl.href, '_blank');
        },
        goInfoPoolDetail(data) {
            let newUrl = this.$router.resolve({
                path: '/layout/info-pool-detail',
                query: {
                    id: data.ProjectId,
                },
            });
            window.open(newUrl.href, '_blank');
        },
        goZjt() {
            window.open('http://zjt.zjbinfo.com/home', '_blank');
        },
        goStudy() {
            window.open('https://ixuexi.aigc.cctv.com/dyzs/login', '_blank');
        },
        goInfoPool() {
            let newUrl = this.$router.resolve({
                path: '/layout/info-pool',
            });
            window.open(newUrl.href, '_blank');
        },
        goSience() {
            window.open('https://www.cstservice.cn/index', '_blank');
        },
        goGoodProductDetail(data) {
            let newUrl = this.$router.resolve({
                path: '/layout/good-product-detail',
                query: {
                    id: data.Id,
                },
            });
            window.open(newUrl.href, '_blank');
        },
        goCulturalHeritageDetail(data) {
            let newUrl = this.$router.resolve({
                path: '/layout/cultural-heritage-detail',
                query: {
                    id: data.Id,
                },
            });
            window.open(newUrl.href, '_blank');
        },
        getProjectDown(data) {
            let accountId = getCookie('accountId');
            if (!accountId) {
                this.downloadDialogTitle = '请登录会员，上传专报信息后，免费下载';
                this.downloadDialogContent = '会员每上传1条专报信息，可下载5条专报信息';
                this.downloadDialogVisible = true;
                return;
            }
            let params = {
                id: data.ProjectId,
                accountid: this.accountId,
            };
            getProjectDown(params).then((res) => {
                // console.log(res);
                if (res.Code == 1) {
                    this.downloadUrl = res.Data;
                    window.open(this.downloadUrl, '_blank');
                } else {
                    this.$message.error(res.Message);
                }
            });
        },
        getProjectDownOther(data) {
            let accountId = getCookie('accountId');
            if (!accountId) {
                this.downloadDialogTitle = '登录会员，免费下载';
                this.downloadDialogContent = '';
                this.downloadDialogVisible = true;
                return;
            }
            let params = {
                id: data.ProjectId,
                accountid: this.accountId,
            };
            getProjectDown(params).then((res) => {
                // console.log(res);
                if (res.Code == 1) {
                    this.downloadUrl = res.Data;
                    window.open(this.downloadUrl, '_blank');
                } else {
                    this.$message.error(res.Message);
                }
            });
        },
        goLogin() {
            this.downloadDialogVisible = false;
            this.$router.push({
              path: '/layout/login'  
            });
        },
        goShareInfoItem(data) {
            let newUrl = this.$router.resolve({
                path: '/layout/share-info-item',
                query: {
                    id: 2,
                    officeId: data.zhujingbanId,
                    officeName: data.zhujingbanName,
                    parentPage: 1,
                },
            });
            window.open(newUrl.href, '_blank');
        },
        getGongxiang() {
            getGongxiang({ current: 1, size: 6 }).then((res) => {
                console.log(res);
                if (res.Code == 1) {
                    this.shareNewsList = res.Data;
                } else {
                    this.$message.error('共享信息请求失败');
                }
            });
        },
        changeBannerRgTab() {
            switch (this.bannerRgTitle) {
                case 'factualNews':
                    this.getFactualNewsList();
                    this.bannerRgMoreLink = '/layout/association-trends?type=1';
                    break;
                case 'associationTrend':
                    this.getBnnerNewsList();
                    this.bannerRgMoreLink = '/layout/association-trends?type=2';
                    break;
                case 'notice':
                    this.getNoticeList();
                    this.bannerRgMoreLink = '/layout/association-trends?type=3';
                    break;
                default:
                    break;
            }
        },
        changeInfoPoolTab() {
            switch (this.infoPoolTitle) {
                case 'everyDayNews':
                    this.getProjectList(4);
                    this.infoPoolMoreLink = '/layout/info-pool?id=4';
                    break;
                case 'specialReportNews':
                    this.getProjectList(3);
                    this.infoPoolMoreLink = '/layout/info-pool?id=3';
                    break;
                case 'shareNews':
                    this.getGongxiang();
                    this.infoPoolMoreLink = '/layout/share-info?id=2';
                    break;
                case 'thinkNews':
                    this.getProjectList(1);
                    this.infoPoolMoreLink = '/layout/info-pool?id=1';
                    break;
                default:
                    break;
            }
        },
        changeInstitutionTab() {
            switch (this.institutionTitle) {
                case 'cityFood':
                    this.getProjectList(4);
                    this.institutionMoreLink = '/layout/city-food';
                    break;
                case 'goodProduct':
                    this.getProjectList(3);
                    this.institutionMoreLink = '/layout/good-product-list';
                    break;
                case 'culturalHeritage':
                    this.getGongxiang();
                    this.institutionMoreLink = '/layout/cultural-heritage-list';
                    break;
                default:
                    break;
            }
        },
        changenewsRgTab() {
            switch (this.newsRgTitle) {
                case 'institution':
                    this.getZhujingbanWork();
                    this.newsRgMoreLink = '/layout/institution-list';
                    break;
                case 'company':
                    this.getCompanyList();
                    this.newsRgMoreLink = '/layout/company-list';
                    break;
                default:
                    break;
            }
        }
    },
};
</script>

<style>
#banner-wrapper,
#accociation-wrapper,
#other-app-wrapper,
#news-wrapper,
#institution-wrapper,
#association-wrapper,
#info-pool-wrapper,
#company-wrapper,
#delicacy-wrapper,
#office-wrapper,
#brand-wrapper,
#headline-news-wrapper {
    width: 100%;
    background: #fff;
    padding-bottom: 30px;
}
#headline-news-wrapper {
    position: relative;
    height: 214px;
}
#headline-news-wrapper .el-carousel__container {
    height: 180px;
}
#headline-news-wrapper-bg {
    position: relative;
    height: 102px;
    width: 100%;
    background: linear-gradient(180deg, #116eba 0%, #ffffff 100%);
}

#headline-news {
    display: block;
    cursor: pointer;
    width: 1280px;
    padding: 50px 90px 0;
    box-sizing: border-box;
    background: #fff;
    text-align: center;
    margin: 0 auto;
}
.headline-news-title {
    font-family: 思源黑体 CN;
    color: #262626;
    font-size: 40px;
    font-weight: 900;
    line-height: 50px;
    padding-bottom: 10px;
    margin-bottom: 20px;
}
.headline-news-origin {
    font-family: 思源黑体 CN;
    font-size: 20px;
    font-weight: 513;
    line-height: 24px;
    color: #262626;
    margin-bottom: 40px;
}
.headline-news-line {
    width: 1200px;
    margin: 0 auto;
    background: #A7C7E3;
    position: relative;
    height: 4px;
}
.headline-news-line:before {
    content: "";
    position: absolute;
    background: #116EBA;
    top: 0;
    left: 0;
    /*width: 300px;*/
    height: 4px;
}
#banner,
#accociation {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
}
.banner-lf {
    float: left;
    width: 588px;
}

.banner-lf .el-carousel__container {
    height: 424px;
}
.banner-lf .el-carousel__indicators--horizontal {
    right: 16px;
    left: unset;
    transform: none;
    bottom: 0px;
}
.banner-item-title {
    position: absolute;
    display: block;
    bottom: 0px;
    background: rgba(0, 0, 0, 0.5);
    box-shadow: inset 0 2px 14px 0 rgba(67, 66, 66, 0.13);
    width: 588px;
    height: 48px;
    line-height: 48px;
    padding-left: 16px;
    padding-right: 100px;
    color: #fff;
    font-size: 16px;
}

.banner-item-img {
    display: block;
    width: 588px;
    height: 424px;
}
.banner-lf .el-carousel__button {
    width: 8px;
    height: 8px;
    border-radius: 4px;
}
.banner-lf .el-carousel__indicator.is-active button {
    background: #116eba;
}
.banner-rg {
    width: 612px;
    height: 424px;
    padding: 12px 24px;
    box-sizing: border-box;
    float: right;
    background: #fff;
    position: relative;
}
.banner-rg .el-tabs__nav-wrap::after {
    height: 0;
}
.banner-rg .el-tabs__active-bar {
    background: url(../assets/image/indexNew/tab_border.jpg) center / cover
        no-repeat;
    height: 10px;
}
.banner-rg .banner-rg_more {
    position: absolute;
    right: 24px;
    z-index: 10;
}
.banner-rg .el-tabs__item,
#info-pool .el-tabs__item,
#institution .el-tabs__item,
.news-rg .el-tabs__item {
    font-family: 思源黑体 CN;
    font-size: 24px;
    height: 50px;
    /* line-height: 28px; */
    padding-bottom: 0 20px 12px;
    text-align: center;
    color: #262626;
    font-weight: normal;
}
.banner-rg .el-tabs__item.is-active,
#info-pool .el-tabs__item.is-active,
#institution .el-tabs__item.is-active,
.news-rg .el-tabs__item.is-active {
    color: #262626;
    font-weight: bold;
}
#info-pool .el-tabs__nav-wrap::after,
#institution .el-tabs__nav-wrap::after,
.news-rg .el-tabs__nav-wrap::after{
    background-color: #116EBA;
}
.banner-info {
    padding-top: 9px;
}
.banner-info-item {
    width: 100%;
    color: #1d2129;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 20px;
    box-sizing: border-box;
    cursor: pointer;
    font-family: 思源黑体 CN;
    font-size: 16px;
    line-height: 19.2px;
    color: #4e5969;
    margin-bottom: 24px;
}
.banner-info-item:hover {
    color: #116eba;
}
.banner-info-item:hover .dot {
    background: #116eba;
}
.banner-info-item .content .title {
    vertical-align: middle;
    display: inline-block;
    width: 440px;
}
.banner-info-item .day {
    font-family: 思源黑体 CN;
    font-size: 30.86px;
    line-height: 37.03px;
    text-align: left;
}
.banner-info-item .bias {
    font-size: 28px;
    font-weight: 200;
}
.banner-info-item .month {
    font-family: Source Sans Pro;
    font-size: 10px;
    font-weight: 400;
    line-height: 12.57px;
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
.banner-info-item .month i {
    font-style: normal;
}
.banner-info-item:hover .dt,
.banner-info-item:hover .dd {
    color: #116eba;
}
.banner-low {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* padding: 15px 20px 0 40px; */
    /* padding-left:30px; */
}
.banner-low .banner-low-item {
    border: 1px solid #0000001a;
    border-bottom: 2px solid #116eba;
}
.banner-low-item .inner {
    width: 133px;
    height: 112px;
    padding-top: 15px;
    position: relative;
    cursor: pointer;
    box-sizing: border-box;
}
.banner-low-item .inner:hover {
    box-shadow: 0px 4px 7.3px 0px #00000040;
}
.banner-low .banner-low-item .inner img {
    display: block;
    margin: 0 auto;
    margin-bottom: 10px;
    width: 48px;
}
.banner-low .banner-low-item:nth-child(3) .inner img {
    width: 48px;
    height: 50px;
}
.banner-low .banner-low-title {
    font-family: 思源黑体 CN;
    font-size: 16px;
    font-weight: bold;
    line-height: 19.2px;
    text-align: center;
    color: #262626;
}
.banner-low .banner-low-tag {
    position: absolute;
    display: inline-block;
    width: 2px;
    height: 16px;
    top: 16px;
    left: 0;
}
.banner-low .banner-low-item:nth-child(1) .banner-low-tag,
.banner-low .banner-low-item:nth-child(3) .banner-low-tag {
    background: #ec801d;
}
.banner-low .banner-low-item:nth-child(2) .banner-low-tag,
.banner-low .banner-low-item:nth-child(4) .banner-low-tag {
    background: #4491e9;
}

#news,
#association,
#other-app,
#institution,
#delicacy,
#office,
#brand {
    width: 1200px;
    margin: 0 auto;
    overflow: hidden;
    position: relative;
}
.accociation-card-list {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.accociation-card {
    width: 282px;
    height: 305px;
    border: 1px solid #e5e5e5;
    overflow: hidden;
    position:relative;
}
.accociation-card .accociation-card_tp {
    box-sizing: border-box;
    height: 90px;
    line-height: 90px;
    padding: 0 30px;
    font-family: 思源黑体 CN;
    font-size: 24px;
    font-weight: 613;
    text-align: left;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.accociation-card .accociation-card_tp  img {
    width: 60px;
    height: 55px;
}
.association-card_btm {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding-top: 10px;
    box-sizing: border-box;
    gap: 5px;
    position: relative;
    z-index: 10;
}
.accociation-card-list .accociation-card:nth-child(1) .association-card_btm:after {
    content: "";
    position: absolute;
    background: url(../assets/image/indexNew/associationBg1.png) center / cover
        no-repeat;
    /* background-position: 50px 50px;
    background-repeat: no-repeat; */
    top: 100px;
    width: 300px;
    height: 116px;
    opacity: 0.25;
 }
 .accociation-card-list .accociation-card:nth-child(2) .association-card_btm:after {
    content: "";
    position: absolute;
    background: url(../assets/image/indexNew/associationBg2.png) center / cover
        no-repeat;
    /* background-position: 50px 50px;
    background-repeat: no-repeat; */
    top: 100px;
    width: 295px;
    height: 116px;
    opacity: 0.07;
 }
 .accociation-card-list .accociation-card:nth-child(3):after {
    content: "";
    position: absolute;
    background: url(../assets/image/indexNew/associationBg3.png) center / cover
        no-repeat;
    bottom:0;
    height: 200px;
    width: 282px;
    /* background-position: 100px 0px; */
 }
 .accociation-card-list .accociation-card:nth-child(4) .association-card_btm:after {
    content: "";
    position: absolute;
    background: url(../assets/image/indexNew/associationBg4.png) center / cover
        no-repeat;
    /* background-position: 50px 50px;
    background-repeat: no-repeat; */
    top: 90px;
    width: 300px;
    height: 240px;
    opacity: 0.13;
    z-index: -1;
 }
 .accociation-card-list .accociation-card:nth-child(1) .accociation-card_tp {
    background: url(../assets/image/indexNew/association1.png) center / cover
        no-repeat;
 }
 .accociation-card-list .accociation-card:nth-child(2) .accociation-card_tp {
    background: url(../assets/image/indexNew/association2.png) center / cover
        no-repeat;
 }
 .accociation-card-list .accociation-card:nth-child(3) .accociation-card_tp {
    background: url(../assets/image/indexNew/association3.png) center / cover
        no-repeat;
 }
 .accociation-card-list .accociation-card:nth-child(4) .accociation-card_tp {
    background: url(../assets/image/indexNew/association4.png) center / cover
        no-repeat;
 }
.association-item a {
    width: 136px;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 42px;
    line-height: 42px;
    font-size: 14px;
    color: #4e5969;
}
.association-item a:hover {
    color: #116eba;
}
.association-item a img {
    vertical-align: middle;
    margin-right: 10px;
}
#other-app {
    display: flex;
    justify-content: space-around;
    align-items: center;
}
#other-app .app-item{
    width: 290px;
    height: 90px;
}
.app-item a{
    cursor: pointer;
    color: #fff;
    font-family: 思源黑体 CN;
    font-size: 24px;
    font-weight: 613;
    line-height: 90px;
    text-align: center;
    padding: 20px 50px;
    display: flex;
    height: 90px;
    justify-content: space-around;
    align-items: center;
    text-align:center;
    box-sizing: border-box;
    margin:0;
}
#other-app .app-item:nth-child(1) {
    background: url(../assets/image/indexNew/app4.png) center / cover
        no-repeat;
}
#other-app .app-item:nth-child(2) {
    background: url(../assets/image/indexNew/app2.png) center / cover
        no-repeat;
}
#other-app .app-item:nth-child(3) {
    background: url(../assets/image/indexNew/app3.png) center / cover
        no-repeat;
}
#other-app .app-item:nth-child(4) {
    background: url(../assets/image/indexNew/app4.png) center / cover
        no-repeat;
}
#delicacy,
#office,
#brand {
    padding-bottom: 20px;
}
.news-lf {
    float: left;
    width: 588px;
    background: #fff;
    /* padding-top: 24px; */
    box-sizing: border-box;
}

.group_title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #116EBA;
    margin-bottom: 20px;
}
.group_title span {
    float: left;
    padding: 0 20px 0 10px;
    height: 45px;
    width: 144px;
    box-sizing: border-box;
    border-bottom: 2px solid #116eba;
    margin-bottom: -2px;
    /* color: #262626; */
    font-family: 思源黑体 CN;
    font-weight: 749px;
    font-size: 24px;
    line-height: 45px;
    text-align: center;
    background: url(../assets/image/indexNew/tab_bg.png) center / cover
        no-repeat;
    color: #fff;
    margin-bottom: 2px;
}
.group_title span.fiveWord {
    width: 168px;
    background: url(../assets/image/indexNew/tab_bg.png) center / cover
        no-repeat;
}
.group_title a,
.banner-rg_more,
.info-pool_more,
.institution_more,
.news_rg_more{
    font-family: 思源黑体 CN;
    font-size: 14px;
    line-height: 16.8px;
    text-align: right;
    color: #86909c;
    cursor: pointer;
}

.group_title a:hover,
.banner-rg_more:hover,
.info-pool_more:hover,
.institution_more:hover,
.news_rg_more:hover {
    color: #116eba;
}
.group-box {
    padding-top: 40px;
}
.rg-group-box {
    padding-top: 30px;
}
.rg-group-box_delicacy {
    padding-top: 10px;
}
.pd_t0 {
    padding-top: 0;
}
.news-rg {
    float: right;
    width: 588px;
    background: #fff;
    /* padding-top: 24px; */
    box-sizing: border-box;
}
.news-rg
    .el-tabs--card
    > .el-tabs__header
    .el-tabs__nav
    .el-tabs__item:nth-child(1) {
    background: #81aeff;
    border: 1px solid #81aeff;
    color: #fff;
}
.news-rg
    .el-tabs--card
    > .el-tabs__header
    .el-tabs__nav
    .el-tabs__item:nth-child(2) {
    background: #bf9cf9;
    border: 1px solid #bf9cf9;
    color: #fff;
}
.news-rg
    .el-tabs--card
    > .el-tabs__header
    .el-tabs__nav
    .el-tabs__item:nth-child(3) {
    background: #1eb2ba;
    border: 1px solid #1eb2ba;
    color: #fff;
}
.news-rg
    .el-tabs--card
    > .el-tabs__header
    .el-tabs__nav
    .el-tabs__item:nth-child(4) {
    background: #59c9f8;
    border: 1px solid #59c9f8;
    color: #fff;
    margin-right: 0;
}
.news-rg .el-tabs--card > .el-tabs__header .el-tabs__nav {
    border: none;
}
.news-rg .el-tabs--card > .el-tabs__header {
    border: none;
}
.news-rg .el-tabs__item {
    width: 137px;
    height: 45px;
    line-height: 45px;
    box-sizing: border-box;
    text-align: center;
    margin-right: 10px;
}
.news-association,
.news-political {
    /* padding-top: 24px; */
}
.news-association p,
.news-political p {
    vertical-align: middle;
    margin-bottom: 6px;
}
.news-association-info,
.news-political-info {
    font-family: 思源黑体 CN;
    font-size: 16px;
    line-height: 19.2px;
    text-align: left;
    color: #4e5969;
    vertical-align: middle;
}
.news-class {
    font-family: 思源黑体 CN;
    font-size: 14px;
    line-height: 16.8px;
    text-align: left;
    margin: 0;
    margin-bottom: 20px;
    color: #86909c;
}
.news-association li,
.news-political li {
    cursor: pointer;
    margin-bottom: 24px;
}
.news-association li:last-child,
.news-political li:last-child {
    margin-bottom: 0;
}
.news-association li:hover .news-association-info,
.news-political li:hover .news-political-info,
.news-association li:hover .news-class,
.news-political li:hover .news-class {
    color: #116eba;
}
.news-association li:hover .dot,
.news-political li:hover .dot {
    background: #116eba;
}

#info-pool,
#company {
    width: 1200px;
    margin: 0 auto;
    background: #fff;
    /* padding-top: 24px; */
    box-sizing: border-box;
    position: relative;
}
.info-pool_more,
.institution_more,
.news_rg_more {
    position: absolute;
    top:20px;
    right: 0;
    z-index: 10;
}
.info-pool-ul{
    margin-top: 40px;
    background: #fff;
    overflow: hidden;
}
.info-pool-lf{
    width: 300px;
    height: 340px;
    background: url('../assets/image/index/info_pool.png') no-repeat 0 0;
    background-size:cover;
    color:#235DD2;
    padding: 28px 24px;
    box-sizing: border-box;
    float:left;
}
.info-pool-lf h3{
    font-family: 思源黑体 CN;
    font-size: 32px;
    text-align: left;
    font-weight:normal;
    margin:0;
    margin-bottom: 6px;
}
.info-pool-lf p,
.info-pool-lf ul{
    font-family: 思源黑体 CN;
    font-size: 14px;
    text-align: left;
    margin:0;
}
.info-pool-lf ul{
    padding-top:50px;
    padding-left:20px;
}
.info-pool-lf ul li{
    list-style-type: disc;
}
.info-pool-rg {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: flex-start;
    float:right;
    width:899px;
}
.info-pool-ul {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: flex-start;
    border-bottom: 1px solid #e5e5e5;
    border-left: 1px solid #e5e5e5;
    margin: 0 auto;
    margin-top: 9px;
}

.info-data {
    width: 298px;
    height: 170px;
    padding: 24px;
    box-sizing: border-box;
    border-top: 1px solid #e5e5e5;
    border-right: 1px solid #e5e5e5;
}
.info-data h4 {
    color: #262626;
    font-family: 思源黑体 CN;
    font-size: 18px;
    margin: 0;
    margin-bottom: 20px;
    line-height: 26px;
    height: 62px;
}
.info-data p {
    color: #6a6a6a;
    font-family: 思源黑体 CN;
    font-size: 14px;
    height: 80px;
}
.info-data-bar {
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 20px;
    border-top: 1px dashed #e5e5e5;
    color: #86909c;
}
.info-pool-tag {
    width: 56px;
    height: 20px;
    padding: 2px 4px 2px 4px;
}
.info-pool-button {
    width: 80px;
    height: 24px;
    line-height: 24px;
    border: 1px solid #116eba;
    color: #116eba;
    cursor: pointer;
    text-align: center;
    box-sizing: border-box;
    transition: all 0.36s;
}
.info-pool-button:hover {
    color: #fff;
    background: #116eba;
}
.delicacy-ul,
.brand-ul {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* padding-top: 24px; */
}
.delicacy-ul {
    padding-top: 10px;
}
.delicacy-item {
    width: 282px;
    height: 254px;
    cursor: pointer;
    position: relative;
}
.delicacy-item img {
    display: block;
    width: 282px;
    height: 216px;
    transition-duration: 0.5s;
}
.delicacy-item:hover img {
    transform: scale(1.05);

}
.delicacy-item p {
    font-family: 思源黑体 CN;
    font-size: 18px;
    text-align: center;
    color: #262626;
    position: absolute;
    width: 100%;
    bottom: 0;
    height: 20px;
    line-height: 20px;
    left: 0;
    z-index: 10;
}
.brand-item img {
    width: 282px;
    height: 216px;
    transition-duration: 0.5s;
}
.brand-item {
    cursor: pointer;
}
.brand-item:hover img {
    transform: scale(1.05);
}
.brand-item p {
    margin: 0;
    padding: 0 16px;
}
.brand-item p:nth-child(2) {
    font-family: 思源黑体 CN;
    font-size: 16px;
    color: #262626;
    padding-top: 5px;
}
.brand-item p:nth-child(3) {
    font-family: 思源黑体 CN;
    font-size: 14px;
    color: #767676;
}
.association_tag{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
#info-pool .el-tabs__item.is-active,
#institution .el-tabs__item.is-active,
.news-rg .el-tabs__item.is-active{
    background: url(../assets/image/indexNew/tab_bg.png) center / cover
        no-repeat;
    height: 45px;
    line-height: 45px;
    color: #fff;
    margin-bottom: 4px;
}
#info-pool  .el-tabs__item,
#institution .el-tabs__item {
    width: 144px !important;
    height: 45px;
    line-height: 45px;
    padding-left: 20px;
    text-align:left;
}
    
#institution .el-tabs__nav .el-tabs__item:nth-child(3),
.news-rg .el-tabs__nav .el-tabs__item:nth-child(2)  {
    width: 168px !important;
}
.news-rg .el-tabs__nav .el-tabs__item:nth-child(3)  {
    width: 192px !important;
    padding-left: 20px;
    text-align:left;
}
#institution .el-tabs__nav .el-tabs__item:nth-child(4){
    width: 216px !important;
    padding-left: 20px;
    text-align:left;
}
</style>
<style scoped>
.swiper-slide {
    width: 110px;
    height: 110px !important;
}
.swiper-slide img.vipLogo {
    width: 110px;
    height: 110px;
    border: 1px solid #E5E5E5;
    cursor: pointer;
    /* margin-right: 24px; */
}
.swipper-div {
    padding-top: 24px;
    display: flex;
    height: 250px;
    justify-content: space-between;
}
.swiper-container{
    width: 490px;
}
.swiper-button-prev,
.swiper-button-next {
    width: 30px !important;
    height: 70px !important;
    /* background: #F2F2F2; */
}
.swiper-button-prev {
    background-image: url(../assets/image/indexNew/arrow.png) !important;
    transform: rotate(180deg);
}
.swiper-button-next {
    background-image: url(../assets/image/indexNew/arrow.png) !important;
}
.swipper-next p,
.swipper-prev p {
    line-height: 70px;
    text-align: center;
    color: #116EBA;
    cursor:pointer;
}
</style>
